import { Edit } from 'froala-editor';

export const toolbarButtons = [
  ['undo', 'redo'],
  ['bold', 'italic', 'paragraphFormat', 'textColor'],
  ['align', 'formatOL', 'formatUL'],
  ['insertLink', 'insertHR'],
  ['fullscreen', 'html'],
] as const;

export const setReadonlyState = (edit: Edit, readonly: boolean | undefined): void => {
  if (readonly) {
    edit.off();
  } else {
    edit.on();
  }
};
